import DistributionContainer from '@components/containers/distribution';
import AppLayout from '@layouts/AppLayout';
import type { FC } from 'react';

const Distribution: FC = () => (
    <AppLayout>
        <DistributionContainer />
    </AppLayout>
);

export default Distribution;
